import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://iadnnqffmmpzsojvztcm.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhZG5ucWZmbW1wenNvanZ6dGNtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzMzkyNjcsImV4cCI6MjA4OTkxNTI2N30.ydUoCHSivz8d0LKwmhP5XkHB2VwXUEZ3JoHwEjQqS84';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
